/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { NavigationExtras, Router, UrlTree } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class ExtendedRouter {
  constructor(
    private router: Router,
    private location: Location
  ) { }

  navigateWithPersistedState(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    const persistedState = this.location.getState() as object;
    const providedState = (extras?.state ?? {}) as object;

    const mergedState = {
      ...persistedState,
      ...providedState
    };

    if (extras || Object.keys(mergedState).length > 0) {
      return this.router.navigate(commands, {
        ...extras,
        state: mergedState
      });
    }

    return this.router.navigate(commands);
  }

  navigate(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    if (extras) {
      return this.router.navigate(commands, extras);
    }

    return this.router.navigate(commands);
  }

  serializeUrl(url: UrlTree): string {
    return this.router.serializeUrl(url);
  }

  createUrlTree(commands: any[], extras?: NavigationExtras): UrlTree {
    return this.router.createUrlTree(commands, extras);
  }

  getCurrentNavigation() {
    return this.router.getCurrentNavigation();
  }
}